export default {
  styles: require('./styles.jsx').default,
  config: require('./config.js').default,
};
